/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Research_Art_SourceInputs */

const en_services_svc_research_art_source = /** @type {(inputs: Services_Svc_Research_Art_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research brief`)
};

const lv_services_svc_research_art_source = /** @type {(inputs: Services_Svc_Research_Art_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izpētes kopsavilkums`)
};

/**
* | output |
* | --- |
* | "Research brief" |
*
* @param {Services_Svc_Research_Art_SourceInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_research_art_source = /** @type {((inputs?: Services_Svc_Research_Art_SourceInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Research_Art_SourceInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_research_art_source(inputs)
	return en_services_svc_research_art_source(inputs)
});